import * as React from 'react';
import { SettingsSection } from '../../../../../../base/components/SettingsSection/SettingsSection';
import { AsidePanelContext } from '../../../../../asidePanel/components/AsidePanel/constants';
import { CLASS_BOARD_DETAILS_SECTION } from '../../../../constants';
import { IColorsSectionProps } from './types';
import { BoardColorsHOC } from '../../hocs/BoardColorsHOC/BoardColorsHOC';
import { BOARD_SECTION_COLORS } from '../../constants';
import { EBoardSetting } from '../../../TabDetails/components/TabDetails/types';
import { TutorialHOC } from '../../../Tutorial/hocs/TutorialHOC/TutorialHOC';

export function ColorsSection ({
}: IColorsSectionProps) {
    const { boardId } = React.useContext(AsidePanelContext);
    const className = CLASS_BOARD_DETAILS_SECTION + ' ' + CLASS_BOARD_DETAILS_SECTION + '--colors';

    return (
        <>
            <TutorialHOC boardSetting={EBoardSetting.COLOR_LABELS} />
            <SettingsSection
                className={className}
                title={BOARD_SECTION_COLORS}
            >
                <BoardColorsHOC
                    boardId={boardId}
                />
            </SettingsSection>
        </>
    );
};
